module.exports = __webpack_public_path__ + "img/swdp.791ff606.png";